<template lang="pug">
  DefaultLayout
    CommonSection(title="Тарифы")
      template(#button)
        UserAutopayStatus
      .b-tariffs()
        ._header
          BaseTabs2(:items="tabs" v-model="tab")
          .period-select Цены за месяц при покупке:
            BaseSelect(v-model="period" hideNotSelected :options="[{ label: 'Год', value: 365 }, { label: 'Месяц', value: 30 }]")
        ._labels
          ._label Проектов
          ._label Хранилище, ГБ
          ._label Задачи и проекты
          ._label Контакты
          ._label Шаблоны проектов
          ._label Диаграмма Ганта
          ._label Список всех задач
          ._label Мои команды
        ._items
          TariffTile._item(
            v-for="tariff in tariffs"
            :key="tariff['@id']"
            :tariff="tariff"
            :selected="actualTariff === tariff"
            :checked="checkedTariff === tariff"
            :showBonus="period === 365"
            @check="checkedTariff = tariff"
          )
        TariffsSidebar._sidebar(:checkedTariff="checkedTariff" :actualTariff="actualTariff")
        ._bottom Оплата взимается только за ваши проекты. Участие в проектах других пользователей — бесплатно!
          Icon(name="tariff-like")
</template>

<script>
import user from '@/model/user';
import paymentApi from '@/api/payment';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import TariffTile from '@/components/tariff/TariffTile.vue';
import TariffsSidebar from '@/components/tariff/TariffsSidebar.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseTabs2 from '@/components/BaseTabs2.vue';
import UserAutopayStatus from '@/components/user/UserAutopayStatus.vue';

export default {
  name: 'PersonalTariffsPage',
  components: {
    BaseTabs2,
    BaseSelect,
    TariffsSidebar,
    TariffTile,
    CommonSection,
    DefaultLayout,
    UserAutopayStatus,
  },
  data() {
    return {
      checkedTariff: null,
      period: 365,
      tab: 'personal',
    };
  },
  created() {
    const payment = this.$route.query?.payment;

    if (payment) {
      paymentApi.update(payment, [], true)
        .then(() => {
          user.fetchSelf();
        });
    }

    this.$store.dispatch('tariff/fetchItems');
  },
  watch: {
    actualTariff: {
      immediate: true,
      handler(val) {
        this.checkedTariff = val;
      },
    },
    notifications: {
      immediate: true,
      handler(val) {
        val.forEach(n => {
          if (n.isViewed) return;
          this.$store.dispatch('notification/view', n);
        });
      },
    },
  },
  computed: {
    notifications() {
      const types = ['account-low-balance', 'account-blocked', 'account-will-be-deleted'];
      return this.$store.state.notification.items.filter(n => types.includes(n.type));
    },
    actualTariff() { return this.$store.getters['tariff/itemsToShow'].find(t => t.id === this.$store.state.auth.user.tariff.id); },
    tariffs() {
      return [...this.$store.getters['tariff/itemsToShowFiltered']]
        .filter(t => (this.tab === 'personal' && t.pricePerDay < 215) || (this.tab === 'corporate' && t.pricePerDay >= 215))
        .sort((a, b) => b.sort - a.sort);
    },
    tabs() {
      return [
        { name: 'personal', label: 'Индивидуальные тарифы' },
        { name: 'corporate', label: 'Корпоративные тарифы' },
      ];
    },
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
  .period-select {
    display: flex;
    align-items: center;
    gap: 20px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #1E3147;
  }

  .tariffs {
    display: grid;
    grid-template-columns: 230px 1fr 300px;

    &__header {
      grid-column: 1 / 3 span;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 60px;
    }

    &__labels {
      padding-top: 160px;
    }

    &__label {
      height: 40px;
      padding: 0 17px;
      display: flex;
      align-items: center;
      border-radius: 8px 0 0 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: #1E3147;

      &:nth-child(even) {
        background: #E4E8F4;
      }
    }

    &__items {
      align-self: start;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 25px;
    }

    &__sidebar {
      margin-left: 27px;
    }

    &__bottom {
      margin-top: 70px;
      grid-column: 1 / 3 span;
      padding: 30px 76px 30px 209px;
      text-align: left;
      font-size: 22px;
      background: #33A1FB;
      border-radius: 66px;
      line-height: 30px;
      letter-spacing: 0.01em;
      color: #FFFFFF;
      position: relative;

      svg {
        position: absolute;
        left: 56px;
        top: 50%;
        width: 123px;
        transform: translateY(-100%);
      }
    }

    @media (max-width: 1500px) {
      grid-template-columns: 230px 1fr;

      &__sidebar {
        grid-column: 1 / 2 span;
        grid-row: 1;
        margin-bottom: 40px;
        margin-left: 0;
      }

      &__header {
        grid-row: 2;
      }

      &__labels {
        grid-column: 1;
        grid-row: 3;
        padding-top: 165px;
      }

      &__items {
        grid-column: 2;
        grid-row: 3;
        padding-top: 20px;
      }
    }

    @media (max-width: 1200px) {
      &__items {
        overflow-x: scroll;
        grid-template-columns: repeat(4, 200px);
      }
    }

    @media (max-width: 1000px) {
      &__header {
        flex-direction: column;
        gap: 40px;
      }

      &__bottom {
        padding: 23px 10px;
        text-align: center;
        font-size: 18px;
        margin-top: 100px;

        svg {
          position: absolute;
          left: 50%;
          top: -90px;
          width: 123px;
          transform: translateX(-50%);
        }
      }
    }

    @media (max-width: 576px) {
      grid-template-columns: 140px 1fr;

      &__label {
        font-size: 12px;
      }
    }
  }
</style>
